import BaseModal from "../BaseModal";
import {Button, Modal} from "react-bootstrap";
import React, {useEffect} from "react";
import {FaSms, FaTelegram, FaWhatsapp} from "react-icons/all";
import {useDispatch, useSelector} from "react-redux";
import {actionChangeStatusShowModalInvitation} from "../../../../../redux/actions/modals/modalInvitation.actions";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {toast} from "react-toastify";
import LoaderModals from "../../loaders/LoaderModals";

const ModalInvitation = () => {

    const dispatch = useDispatch();
    const {status_show_modal, code, link,loader_modal,text} = useSelector(state => state.modalInvitation);
    const {token} = useSelector(state => state.user);

    const handleClose = () => {
        dispatch(actionChangeStatusShowModalInvitation(false));
    }

    useEffect(() => {
        if (status_show_modal) {
            dispatch({type: "FETCH_INVITATION_LINK", payload: {token}});
        }
        // eslint-disable-next-line
    }, [status_show_modal]);

    const copy = () => {
        toast.success('متن مورد نظر کپی شد');
    }

    return (
        <React.Fragment>
            <BaseModal title='دوستت رو دعوت کن'
                       show={status_show_modal}
                       dialogClassName=''
                       handleClose={handleClose}>
                <Modal.Body>
                    {!loader_modal ?
                        <div className='box-modal-invitation'>
                            <div className='box-head-modal-invitation text-center'>
                                <h2>
                                    <div>20,000 تومان هدیه بده</div>
                                    <div>20,000 تومان هدیه بگیر</div>
                                </h2>
                                <p>
                                    برای ثبت نام و ثبت اولین سفارش
                                </p>
                            </div>
                            <div className='box-link-adn-code-modal-invitation'>
                                <p>لینک یا کد معرفی اختصاصیت رو برای دوستت ارسال کن</p>
                                <div className='list-link-adn-code-modal-invitation'>
                                    <div>
                                        <CopyToClipboard text={link} onCopy={copy}>
                                            <Button variant="success" className='base-btn-green'>کپی</Button>
                                        </CopyToClipboard>
                                        <span className='text-link-invitation'>{link}</span>
                                    </div>
                                    <div>
                                        <CopyToClipboard text={code} onCopy={copy}>
                                            <Button variant="success" className='base-btn-green'>کپی</Button>
                                        </CopyToClipboard>
                                        <span>Code : {code}</span>
                                    </div>
                                </div>
                            </div>
                            <div className='box-share-by-apps-modal-invitation'>
                                <ul>
                                    <li>
                                        <a href={`sms:?&body=${text} ${link}`}>
                                            <FaSms size={40}/>
                                            <div>
                                                <span>ارسال از طریق</span>
                                                <span>پیامک</span>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a href={`whatsapp://send?text=${text} ${link}`}>
                                            <FaWhatsapp size={40} color='green'/>
                                            <div>
                                                <span>ارسال از طریق</span>
                                                <span>واتساپ</span>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a href={`tg://msg_url?url=${text} ${link}&amp;text=فروت مروت`}>
                                            <FaTelegram size={40}/>
                                            <div>
                                                <span>ارسال از طریق</span>
                                                <span>تلگرام</span>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        :<LoaderModals/>}
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </BaseModal>
        </React.Fragment>
    )
}

export default ModalInvitation;